import type { Section } from "@/lib/sections";
import { SECTIONS } from "@/lib/sections";
import { PlaceholderSectionCard } from "@/components/PlaceholderSectionCard";

export default function SectionPage({ section, index }: { section: Section; index: number }) {
  return (
    <section data-testid={`section-page-${section.slug}`}>
      <div className="fade-up mb-8 sm:mb-10">
        <p className="font-mono text-xs font-medium tracking-widest text-amber-600">
          {String(index + 1).padStart(2, "0")} / {String(SECTIONS.length).padStart(2, "0")}
        </p>
        <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight text-[#1B2A4A] sm:text-5xl" data-testid="section-title">
          {section.title}
        </h1>
        <p className="mt-3 max-w-2xl text-sm text-slate-600 sm:text-base" data-testid="section-subtitle">{section.subtitle}</p>
      </div>
      <PlaceholderSectionCard section={section} />
    </section>
  );
}
